import { TableWrap } from "../../ui/Table";
import "./styles.scss";

// The rows come from the caller: <tr><td>#</td><td>Team</td> then the numbers.
const StandingsTable = ({ children }: { children: React.ReactNode }) => {
  return (
    <TableWrap className="standings-table-container">
      <table className="ui-table standings-table standings-table--medals">
        <thead>
          <tr>
            <th>#</th>
            <th>Team</th>
            <th>MP</th>
            <th>W</th>
            <th>L</th>
            <th>Sets</th>
            <th>Pts Diff</th>
            <th>Pts</th>
          </tr>
        </thead>
        <tbody>{children}</tbody>
      </table>
    </TableWrap>
  );
};

export default StandingsTable;
